import { api } from '@gik/core/api';

export interface ICalendarEventClaimBasePayload {
  description?: string;
  note?: string;
  serviceSlug?: string;
  grubhubUrl?: string;
  carType?: string;
}
export interface ICalendarEventClaimUpdatePayload extends Partial<ICalendarEventClaimCreatePayload> {}
export interface ICalendarEventClaimCreatePayload extends ICalendarEventClaimBasePayload {
  calendarEntryId: string;
  claimDate: string;
  // test if it is possible to claim without actually claiming
  test?: boolean;
  // attach claim to existing order (claim conflict resolution)
  orderId?: number;
  orderKey?: string;
}

export async function claimExistsForEvent(entryId: string): Promise<boolean> {
  const url = `claims?entryIds=${entryId.toLowerCase()}&fields=id`;
  const response = await api.get(url);
  const claims = (await response.json()) as { id: string }[];
  return claims.length > 0;
}
export async function unclaim(claimId: string): Promise<Response> {
  const url = `claims/${claimId}`;
  return await api.delete(url);
}
export async function updateClaim(
  claimId: string,
  updateClaimRequest: ICalendarEventClaimUpdatePayload
): Promise<Response> {
  const url = `claims/${claimId}`;
  return api.patch(url, { json: updateClaimRequest });
}

export async function createClaim(createClaimRequest: ICalendarEventClaimCreatePayload): Promise<Response> {
  const url = `claims`;
  return await api.post(url, { json: createClaimRequest });
}
